
gsap.registerPlugin(ScrollTrigger);


function initGSAPAnimations() {
    // Animación del top-content
    const topContent = document.querySelector('#top-content');
    if (topContent && window.innerWidth > 900) {
        const bg = document.querySelector('.top-content__bg');
        const img = document.querySelector('.top-content__img img');
        const key = document.querySelector('.top-content__key img');

        gsap.to(topContent, {
            scrollTrigger: {
                trigger: topContent,
                start: 'top top',
                end: '+=250',
                scrub: true,
                pin:  window.innerWidth >= 1920 ? false : true,
            },
        });

        gsap.to(bg, {
            scrollTrigger: {
                trigger: topContent,
                start: 'top top',
                end: 'bottom top',
                scrub: true,
            },
            scale: 8,
            ease: 'none',
        });

        gsap.to(img, {
            scrollTrigger: {
                trigger: topContent,
                start: 'top top',
                end: '10%',
                scrub: 0.2,
            },
            opacity: 0,
            ease: 'none',
        });

        gsap.to(key, {
            scrollTrigger: {
                trigger: topContent,
                start: 'top top',
                end: '10%',
                scrub: 0.2,
            },
            rotation: 90,
            ease: 'none',
        });
    }

    // Animación de las estadísticas
    const statistics = document.querySelectorAll('.statistics__item');
    if (statistics && window.innerWidth < 1920) {
        statistics.forEach((item, index) => {
            const countElement = item.querySelector('.statistics__count');
            const finalNumber = parseInt(countElement.dataset.number, 10);
            const delayTime = index * 0.5;

            gsap.from(item, {
                scrollTrigger: {
                    trigger: item,
                    start: 'top 80%',
                    end: 'bottom top',
                    toggleActions: 'play none none none',
                },
                y: 50,
                opacity: 0,
                duration: 1,
                ease: 'power2.out',
                delay: delayTime,
            });

            gsap.fromTo(
                countElement,
                { innerText: 0 },
                {
                    innerText: finalNumber,
                    duration: 4,
                    delay: delayTime,
                    scrollTrigger: {
                        trigger: item,
                        start: 'top 80%',
                        toggleActions: 'play none none none',
                    },
                    snap: { innerText: 1 },
                    ease: 'power2.out',
                    onUpdate: function () {
                        countElement.innerText = Math.floor(countElement.innerText);
                    },
                },
            );
        });
    }
    if (statistics && window.innerWidth >= 1920) {
        statistics.forEach((item, index) => {
        const countElement = item.querySelector('.statistics__count');
        const finalNumber = parseInt(countElement.dataset.number, 10);
        countElement.innerHTML = finalNumber;
        });
    }

    // Animación de la sección de información
    const info_section = document.querySelector('.info-seccion');
    if (info_section) {
        const bg = document.querySelector('.info-seccion__cube');
        const svgPaths = document.querySelectorAll('.info-seccion__texture svg path');

        gsap.to(bg, {
            scrollTrigger: {
                trigger: info_section,
                start: window.innerWidth > 900 ? 'top +=800' : 'top +=1000',
                end: 'bottom bottom',
                scrub: 1,
            },
            scale: window.innerWidth > 900 ? 20 : 15,
            ease: 'power2.inOut',
        });

        gsap.to(svgPaths, {
            scrollTrigger: {
                trigger: info_section,
                start: window.innerWidth > 900 ? 'top +=600' : 'top +=800',
                end: 'bottom 130%',
                scrub: true,
            },
            duration: 2,
            fill: '#ffffff',
            ease: 'power2.inOut',
            stagger: 0.5,
            markers: true,
        });
    }

    // Animación del acordeón lateral
    const aside_accordion = document.querySelector('.aside-accordion');
    if (aside_accordion && window.innerWidth > 900) {
        const bg = document.querySelector('.aside-accordion__box');

        gsap.to(bg, {
            scrollTrigger: {
                trigger: aside_accordion,
                start: 'top 80%',
                end: 'bottom 130%',
                scrub: true,
            },
            scale: 5,
            ease: 'power2.inOut',
        });
    }

    // Animación del acordeón de información
    const infoAccordion = document.querySelector('.info-accordion');
    if (infoAccordion) {
        const items = gsap.utils.toArray('.info-accordion__item .info-accordion__wrap');

        gsap.timeline({
            scrollTrigger: {
                trigger: '.info-accordion__info',
                start: window.innerWidth > 900 ? 'top 30%' : 'top +=250',
                end: 'bottom bottom',
                pinSpacing: false,
                scrub: 1,
            },
        })
            .to(items.slice(0, -1), {
                height: 0,
                paddingBottom: 0,
                stagger: 0.2,
                ease: 'power2.inOut',
            })
            .to(
                items.slice(0, -1),
                {
                    marginBottom: window.innerWidth > 900 ? -50 : -30,
                    stagger: 0.2,
                    ease: 'power2.inOut',
                },
                '<',
            );
    }
}